export default {
    profile: 'Profil',
    // Dopisek przy asystencie, gdy ma własne imię (szyna, dolny pasek, nagłówek rozmowy)
    yourAssistant: 'Twój asystent',
    yourAssistantTitle: '{name} — Twój asystent',
    groups: {
        main: 'Główne',
        affairs: 'Sprawy',
        home: 'Bliscy i dom',
        health: 'Zdrowie',
        money: 'Zakupy i pieniądze',
        beta: 'Nowe wersje',
        legacy: 'Stare wersje',
    },
    // Jedno zdanie pod nazwą modułu na kaflu panelu „Wszystko" (też do wyszukiwania).
    descriptions: {
        assistant: 'Mów, co robisz — zapisze',
        // kafel asystenta z własnym imieniem („Ola”)
        assistantNamed: 'Twój asystent — mów, co robisz, a zapisze',
        planer2: 'Dzień, tydzień, zadania',
        basket: 'Lista zakupów i tryb w sklepie',
        food2: 'Posiłki, plan tygodnia, makro',
        forma: 'Sen, treningi, waga',
        wallet: 'Wydatki, płatności, budżet',
        people: 'Urodziny, prezenty, kontakty',
        pets: 'Szczepienia, obsługi, waga',
        devices: 'Serwisy, gwarancje, przebieg',
        habits: 'Codzienne odhaczanie, serie',
        medications: 'Dawki na dziś, zapas',
        projects: 'Zadania z celem i terminem',
        notes: 'Notatki z nagłówkami i listami',
        places: 'Zapisane punkty na mapie',
        food: 'Stare posiłki i plan — zastąpiło je Jedzenie',
        shopping: 'Stara lista zakupów — zastąpił ją Koszyk',
        finance: 'Stare wydatki i kredyty — zastąpił je Portfel',
        planner: 'Stary dzień i tydzień — zastąpił go Planer',
    },
    rail: {
        all: 'Wszystko',
        current: 'Tu jesteś: {name}',
        expand: 'Rozwiń menu',
        collapse: 'Zwiń menu',
    },
    bottom: {
        label: 'Nawigacja',
        more: 'Więcej',
    },
    launcher: {
        title: 'Wszystkie moduły',
        search: 'Szukaj modułu lub strony…',
        close: 'Zamknij',
        empty: 'Nic nie pasuje do „{query}”.',
        pin: 'Przypnij „{name}” do menu',
        unpin: 'Odepnij „{name}” z menu',
        isNew: 'Nowe',
        current: 'Tu jesteś',
        legacyShow: 'Pokaż stare wersje',
        legacyHide: 'Schowaj stare wersje',
        pinnedCount: 'Przypięte: {n}',
        menuSettings: 'Ustawienia menu',
    },
    modules: {
        assistant: 'Asystent',
        planner: 'Planer (stary)',
        planer2: 'Planer',
        food: 'Jedzenie (stare)',
        shopping: 'Zakupy (stare)',
        basket: 'Koszyk',
        food2: 'Jedzenie',
        forma: 'Forma',
        finance: 'Finanse',
        wallet: 'Portfel',
        projects: 'Projekty',
        notes: 'Notatnik',
        people: 'Ludzie',
        pets: 'Zwierzęta',
        devices: 'Sprzęty',
        habits: 'Nawyki',
        medications: 'Leki',
        places: 'Miejsca',
        settings: 'Ustawienia',
    },
    pages: {
        planer2: {
            day: 'Dzień',
            week: 'Tydzień',
            month: 'Miesiąc',
            tasks: 'Zadania',
            settings: 'Ustawienia',
        },
        food: {
            meals: 'Posiłki',
            products: 'Produkty',
            semiProducts: 'Półprodukty',
            mealCategories: 'Kategorie posiłków',
            daySets: 'Zestawy dnia',
            mealPlan: 'Plan posiłków',
        },
        shopping: {
            list: 'Lista zakupowa',
            shops: 'Sklepy',
            categories: 'Kategorie sklepowe',
        },
        basket: {
            toBuy: 'Do kupienia',
            lists: 'Listy i szablony',
            shops: 'Sklepy',
            history: 'Historia',
            settings: 'Ustawienia',
        },
        food2: {
            today: 'Dziś',
            week: 'Tydzień',
            meals: 'Posiłki',
            products: 'Produkty',
            settings: 'Ustawienia',
        },
        forma: {
            now: 'Teraz',
            sleep: 'Sen',
            activity: 'Ruch',
            weight: 'Waga',
        },
        finance: {
            overview: 'Przegląd',
            expenses: 'Wydatki',
            incomes: 'Przychody',
            payments: 'Płatności',
            loans: 'Kredyty',
            categories: 'Kategorie',
        },
        wallet: {
            now: 'Teraz',
            transactions: 'Transakcje',
            plans: 'Plany',
            analysis: 'Analiza',
            settings: 'Ustawienia',
        },
        projects: {
            projects: 'Projekty',
            templates: 'Szablony',
        },
        notes: {
            notes: 'Notatki',
        },
        people: {
            people: 'Osoby',
        },
        pets: {
            pets: 'Zwierzęta',
        },
        devices: {
            devices: 'Sprzęty',
        },
        habits: {
            habits: 'Nawyki',
        },
        medications: {
            medications: 'Leki',
        },
        places: {
            map: 'Mapa',
            lists: 'Listy miejsc',
            settings: 'Ustawienia',
        },
        settings: {
            profile: 'Profil',
            goals: 'Cele i preferencje',
            calendar: 'Kalendarz Google',
            menu: 'Menu',
            topBar: 'Górny pasek',
            app: 'Aplikacja',
            ai: 'Zużycie AI',
            adminAi: 'Koszty AI',
        },
    },
    topBar: {
        startScreen: 'Ekran początkowy',
        shoppingTitle: 'Przejdź listę w sklepie',
        basketTitle: 'Koszyk — lista domyślna',
        timersTitle: 'Minutniki',
        timerDone: 'gotowe',
        phaseEnded: 'Koniec fazy',
        pomodoroPhase: 'Pomodoro — {phase}',
        searchTitle: 'Szukaj (⌘K)',
        noNotifications: 'Brak powiadomień',
        timersFinished: 'Minutnik skończył odliczanie. | {n} minutniki skończyły odliczanie. | {n} minutników skończyło odliczanie.',
        pomodoroFinished: 'Pomodoro: koniec fazy ({phase}).',
        walletHeading: 'PORTFEL',
        when: {
            overdue: 'po terminie',
            today: 'dziś',
            tomorrow: 'jutro',
        },
        paid: 'Zapłacone',
        budgetExceeded: 'Budżet „{name}" przekroczony o {amount}',
        nothingNew: 'Nic nowego.',
        shopping: { label: 'Tryb zakupów', hint: 'Stara lista zakupowa do odhaczania w sklepie, z liczbą pozycji' },
        basket: { label: 'Koszyk', hint: 'Listy zakupów — otwiera listę domyślną Koszyka' },
        timers: { label: 'Minutnik', hint: 'Minutniki z odliczaniem w pasku' },
        pomodoro: { label: 'Pomodoro', hint: 'Sesje pracy i przerw' },
        search: { label: 'Szukaj', hint: 'Wyszukiwarka (działa też ⌘K / Ctrl+K)' },
        notifications: { label: 'Powiadomienia', hint: 'Koniec minutnika i fazy Pomodoro' },
    },
    shell: {
        collapse: 'Zwiń panel',
        collapseSidebar: 'Zwiń panel boczny',
        expand: 'Rozwiń panel',
        expandSidebar: 'Rozwiń panel boczny',
    },
    search: {
        week: 'Tydzień',
        label: 'Szukaj w aplikacji',
        placeholder: 'Gdzie chcesz przejść?',
        empty: 'Nic takiego tu nie ma.',
    },
};
